export const setupVitePreloadErrorHandle = () => {
  window.addEventListener('vite:preloadError', () => {
    const key = 'vite_reload_count';
    const count = Number(sessionStorage.getItem(key) || 0);

    // 只有当刷新次数少于3次时才自动刷新，避免可能存在的无限刷新循环
    if (count < 3) {
      sessionStorage.setItem(key, String(count + 1));
      window.location.reload();
    } else {
      console.error('Resource loading failed and automatic refreshing has been stopped');
    }
  });
};
